import { Page, View } from '@react-pdf/renderer';
import React from 'react';
import { Footer, Header, HeaderEndComponent } from '../../comps';
import { ColorSet } from 'src/redux/reducers/theme';
import { pdfStyles } from '../../pdfStyles';
import { Card } from './Card';

const CARD_WIDTH = 250;

type Slot = {
  title: string;
  children: React.ReactNode;
};

interface CardsPageProps {
  colors: ColorSet;
  slot1: Slot;
  slot2: Slot;
  slot3?: Slot;
  slot4: Slot;
  slot5: Slot;
  slot6: Slot;
  logoSrc?: string;
}
const CardsPage: React.FC<CardsPageProps> = ({ colors, slot1, slot2, slot3, slot4, slot5, slot6, logoSrc }) => {
  return (
    <Page size="A4" orientation="landscape">
      <Header colors={colors} endComponent={<HeaderEndComponent title="BACK TO TOP" />} logoSrc={logoSrc} />
      <View style={pdfStyles.section}>
        <View style={{ flexDirection: 'row', gap: 16 }}>
          <View style={{ width: CARD_WIDTH }}>
            <Card title={slot1.title} colors={colors}>
              {slot1.children}
            </Card>
          </View>
          <View style={{ width: CARD_WIDTH }}>
            <Card title={slot2.title} colors={colors}>
              {slot2.children}
            </Card>
          </View>
          {slot3 && (
            <View style={{ width: CARD_WIDTH }}>
              <Card title={slot3.title} colors={colors}>
                {slot3.children}
              </Card>
            </View>
          )}
        </View>
        <View style={{ flexDirection: 'row', gap: 16, marginTop: 16, height: 320, alignItems: 'center' }}>
          <View style={{ width: CARD_WIDTH }}>
            <Card title={slot4.title} colors={colors}>
              {slot4.children}
            </Card>
          </View>
          <View style={{ width: CARD_WIDTH }}>
            <Card title={slot5.title} colors={colors}>
              {slot5.children}
            </Card>
          </View>
          <View style={{ width: CARD_WIDTH }}>
            <Card title={slot6.title} colors={colors}>
              {slot6.children}
            </Card>
          </View>
        </View>
      </View>
      <Footer colors={colors} />
    </Page>
  );
};

export default CardsPage;
